<template>
  <md-dialog :md-active.sync="show" :md-fullscreen="true">
    <md-dialog-title>{{ $t("typeInfo.damage") }}</md-dialog-title>
    <md-dialog-content>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-50">
          <md-field>
            <select v-model="item.damage_type" name="damageType">
              <option disabled value="">{{ $t("typeInfo.damageType") }}</option>
              <option v-for="(dt, key) in damageTypeList" :value="key" :key="key">{{ dt }}</option>
            </select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <select v-model="item.damage_level" name="damageLevel">
              <option disabled value="">{{ $t("typeInfo.damageLevel") }}</option>
              <option v-for="(dl, key) in damageLevelList" :value="key" :key="key">{{ dl }}</option>
            </select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50">
          <md-field>
            <select v-model="item.damage_dead" name="damageDead">
              <option disabled value="">{{ $t("typeInfo.damageDead") }}</option>
              <option v-for="(dd, key) in damageDeadList" :value="key" :key="key">{{ dd }}</option>
            </select>
          </md-field>
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="close()">Ok</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { getDomain } from '@/assets/scripts/domainsManager'

const DAMAGE_TYPE = 'forest_damage_type'
const DAMAGE_LEVEL = 'forest_damage_level'
const DEAD_TREE = 'forest_damage_dead'

export default {
  name: 'DamageDialog',
  props: ['item', 'show'],
  data: () => ({
    damageTypeList: {},
    damageLevelList: {},
    damageDeadList: {}
  }),
  mounted () {
    getDomain(DAMAGE_TYPE).then(data => {
      this.damageTypeList = data[this.$i18n.locale]
    })
    getDomain(DAMAGE_LEVEL).then(data => {
      this.damageLevelList = data[this.$i18n.locale]
    })
    getDomain(DEAD_TREE).then(data => {
      this.damageDeadList = data[this.$i18n.locale]
    })
  },
  methods: {
    close: function () {
      this.$emit('close', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
